import React from 'react';
import { Link } from 'react-router-dom';

const MaieuticaCTA = () => (
  <section data-testid="maieutica-section" className="py-24 bg-[#0A0A0A] border-y border-[#00FF41]/20">
    <div className="max-w-4xl mx-auto px-6 text-center">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00FF41] mb-6">Maieutica</p>
      
      <h2 className="text-4xl md:text-5xl font-black text-white mb-8 leading-tight">
        Quando entri nell'AI_COVO,<br />
        <span className="text-[#00FF41]">qualcuno tirerà fuori il meglio da te.</span>
      </h2>
      
      <p className="text-xl text-zinc-400 mb-8 max-w-2xl mx-auto leading-relaxed">
        Come Socrate con i suoi allievi, noi crediamo che ogni persona abbia già dentro di sé 
        il proprio potenziale. Il nostro compito è <strong className="text-white">farlo emergere</strong>.
      </p>
      
      <div className="grid md:grid-cols-3 gap-6 mb-12">
        <div className="border border-white/10 p-6">
          <p className="text-3xl mb-3">🧒</p>
          <h3 className="text-white font-bold mb-2">Per i Giovani</h3>
          <p className="text-zinc-500 text-sm">Non sei "difficile". Hai solo bisogno di qualcuno che creda in te.</p>
        </div>
        <div className="border border-white/10 p-6">
          <p className="text-3xl mb-3">👴</p>
          <h3 className="text-white font-bold mb-2">Per gli Anziani</h3>
          <p className="text-zinc-500 text-sm">La tua esperienza è preziosa. Qui puoi trasmetterla.</p>
        </div>
        <div className="border border-white/10 p-6">
          <p className="text-3xl mb-3">🌍</p>
          <h3 className="text-white font-bold mb-2">Per Tutti</h3>
          <p className="text-zinc-500 text-sm">Chiunque tu sia, qui troverai chi crede nel tuo valore.</p>
        </div>
      </div>
      
      <div className="bg-[#00FF41]/10 border border-[#00FF41]/30 p-8 mb-8">
        <p className="text-lg text-zinc-300 italic mb-4">
          "La maieutica è l'arte di far partorire le menti, di tirare fuori ciò che è già dentro."
        </p>
        <p className="text-[#00FF41] font-mono text-sm">— Socrate</p>
      </div>
      
      <Link to="/dona" className="font-mono text-sm text-[#00FF41] hover:text-[#33FF66] transition-colors uppercase tracking-wider">
        Scopri come partecipare →
      </Link>
    </div>
  </section>
);

export default MaieuticaCTA;
